const messaging = {
    en: {
        "msg.title": "Notifications & templates",
        "msg.templates": "Message templates",
        "msg.log": "Message log",
        "msg.event": "Event",
        "msg.channel": "Channel",
        "msg.subject": "Subject",
        "msg.body": "Message",
        "msg.enabled": "Enabled",
        "msg.save": "Save",
        "msg.placeholders": "Placeholders",
        "msg.sms": "SMS",
        "msg.email": "Email",
        "msg.inapp": "In-app",
        "msg.event_status_change": "Car status change",
        "msg.recipient": "Recipient",
        "msg.status": "Status",
        "msg.date": "Date",
        "msg.allChannels": "All channels",
        "msg.none": "No messages logged yet",
        "msg.sent": "Sent",
        "msg.failed": "Failed",
        "msg.simulated": "Simulated",
        "msg.skipped": "Skipped",
        "msg.test": "Send test",
        "msg.testSms": "Test SMS",
        "msg.testEmail": "Test email",
        "msg.testHint": "Sends a real message to your own phone/email if a provider is configured.",
        "msg.saved": "Template saved",
    },
    ru: {
        "msg.title": "Уведомления и шаблоны",
        "msg.templates": "Шаблоны сообщений",
        "msg.log": "Журнал сообщений",
        "msg.event": "Событие",
        "msg.channel": "Канал",
        "msg.subject": "Тема",
        "msg.body": "Сообщение",
        "msg.enabled": "Включено",
        "msg.save": "Сохранить",
        "msg.placeholders": "Переменные",
        "msg.sms": "SMS",
        "msg.email": "Email",
        "msg.inapp": "В приложении",
        "msg.event_status_change": "Смена статуса авто",
        "msg.recipient": "Получатель",
        "msg.status": "Статус",
        "msg.date": "Дата",
        "msg.allChannels": "Все каналы",
        "msg.none": "Сообщений пока нет",
        "msg.sent": "Отправлено",
        "msg.failed": "Ошибка",
        "msg.simulated": "Симуляция",
        "msg.skipped": "Пропущено",
        "msg.test": "Тест",
        "msg.testSms": "Тест SMS",
        "msg.testEmail": "Тест Email",
        "msg.testHint": "Отправляет реальное сообщение на ваш телефон/почту, если провайдер настроен.",
        "msg.saved": "Шаблон сохранён",
    },
    geo: {
        "msg.title": "შეტყობინებები და შაბლონები",
        "msg.templates": "შეტყობინების შაბლონები",
        "msg.log": "შეტყობინებების ჟურნალი",
        "msg.event": "მოვლენა",
        "msg.channel": "არხი",
        "msg.subject": "სათაური",
        "msg.body": "ტექსტი",
        "msg.enabled": "ჩართული",
        "msg.save": "შენახვა",
        "msg.placeholders": "ცვლადები",
        "msg.sms": "SMS",
        "msg.email": "ელფოსტა",
        "msg.inapp": "აპლიკაციაში",
        "msg.event_status_change": "ავტომობილის სტატუსის ცვლილება",
        "msg.recipient": "მიმღები",
        "msg.status": "სტატუსი",
        "msg.date": "თარიღი",
        "msg.allChannels": "ყველა არხი",
        "msg.none": "შეტყობინებები ჯერ არ დაფიქსირებულა",
        "msg.sent": "გაგზავნილი",
        "msg.failed": "ჩავარდა",
        "msg.simulated": "სიმულაცია",
        "msg.skipped": "გამოტოვებული",
        "msg.test": "ტესტის გაგზავნა",
        "msg.testSms": "ტესტ SMS",
        "msg.testEmail": "ტესტ ელფოსტა",
        "msg.testHint": "აგზავნის რეალურ შეტყობინებას თქვენს ტელეფონზე/ელფოსტაზე, თუ პროვაიდერი კონფიგურირებულია.",
        "msg.saved": "შაბლონი შენახულია",
    },
};

export default messaging;
